export default function Team() {
  return (
    <section id="equipe" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-10">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="text-primary-600 text-sm font-semibold uppercase tracking-widest">Notre Équipe</span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mt-3 leading-tight">
            Des passionnés au service de votre réussite
          </h2>
          <p className="mt-4 text-foreground-700">
            Derrière Godwin Logistics, une équipe engagée dirigée par un expert du fret maritime cumulant plus de 10 ans d'expérience terrain.
          </p>
        </div>

        <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200">
          <div className="grid lg:grid-cols-5 gap-8 items-center">
            <div className="lg:col-span-2 flex items-center justify-center p-8 lg:p-12 bg-primary-50">
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-full bg-primary-500 flex items-center justify-center shrink-0">
                <span className="text-white font-heading text-3xl md:text-4xl font-bold">SNK</span>
              </div>
            </div>
            <div className="lg:col-span-3 p-8 md:p-12">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold uppercase tracking-wider">
                <i className="ri-medal-line w-4 h-4 flex items-center justify-center"></i>
                Direction Générale
              </div>
              <h3 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mt-4">
                Sympho Ntumba Kobabiya
              </h3>
              <p className="text-primary-600 font-semibold mt-1">Fondateur & Directeur Général</p>
              <p className="mt-5 text-foreground-700 leading-relaxed">
                Expert depuis plus de 10 ans dans le domaine du fret maritime, Sympho a bâti Godwin Logistics autour d'une conviction simple :
                chaque colis mérite le même soin, qu'il traverse un océan ou une frontière. Il dirige aujourd'hui une équipe multidisciplinaire
                qui met son énergie au service de vos flux internationaux.
              </p>

              <div className="mt-6 flex flex-wrap gap-3 text-sm">
                <a href="tel:+243993619615" className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 font-medium">
                  <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>+243 993 619 615
                </a>
                <a href="mailto:sympho.kobabiya@godwin-logistics.com" className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 font-medium">
                  <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>sympho.kobabiya@godwin-logistics.com
                </a>
              </div>

              <div className="mt-8 grid grid-cols-3 gap-4">
                {[
                  { n: '10+', l: "Années d'expertise" },
                  { n: '15', l: 'Experts dédiés' },
                  { n: '3', l: 'Continents actifs' },
                ].map((s, i) => (
                  <div key={i} className="p-4 rounded-md bg-background-100 border border-background-200 text-center">
                    <div className="font-heading text-2xl font-bold text-primary-600">{s.n}</div>
                    <div className="text-xs text-foreground-600 mt-1">{s.l}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 grid md:grid-cols-2 gap-6">
          <div className="bg-background-50 rounded-lg border border-background-200 p-8 md:p-10">
            <div className="flex items-center gap-5">
              <div className="w-16 h-16 rounded-full bg-secondary-500 flex items-center justify-center shrink-0">
                <span className="text-white font-heading text-xl font-bold">BM</span>
              </div>
              <div>
                <h4 className="font-heading text-xl font-bold text-foreground-900">Blaise Mununga</h4>
                <p className="text-sm text-primary-600 font-semibold mt-0.5">Responsable Opérations</p>
              </div>
            </div>
            <p className="text-sm text-foreground-600 mt-5 leading-relaxed">
              Pilote les opérations quotidiennes et assure le suivi de vos colis de l'entrepôt chinois jusqu'à la RDC.
            </p>
            <div className="mt-5 flex flex-wrap gap-3 text-sm">
              <a href="tel:+243846959425" className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 font-medium">
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>+243 846 959 425
              </a>
              <a href="mailto:blaise.mununga@godwin-logistics.com" className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 font-medium">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>blaise.mununga@godwin-logistics.com
              </a>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg border border-background-200 p-8 md:p-10">
            <div className="flex items-center gap-5">
              <div className="w-16 h-16 rounded-full bg-accent-500 flex items-center justify-center shrink-0">
                <span className="text-white font-heading text-xl font-bold">AL</span>
              </div>
              <div>
                <h4 className="font-heading text-xl font-bold text-foreground-900">Alex</h4>
                <p className="text-sm text-primary-600 font-semibold mt-0.5">Coordinateur Logistique</p>
              </div>
            </div>
            <p className="text-sm text-foreground-600 mt-5 leading-relaxed">
              Votre interlocuteur pour le suivi en temps réel et la coordination entre les équipes Lubumbashi et Chine.
            </p>
            <div className="mt-5 flex flex-wrap gap-3 text-sm">
              <a href="tel:+243999209934" className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 font-medium">
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>+243 999 209 934
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}